function setInputFilter(textbox, inputFilter)
{
  ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
    textbox.addEventListener(event, function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}

function register()
{
  // Limit siret field to numbers.
  if (document.getElementById("acf-field_5dea108873710")) {
    setInputFilter(document.getElementById("acf-field_5dea108873710"), function (value) {
      return /^\d*\.?\d*$/.test(value);
    });
  }

  // Force city and address fields to uppercase.
  if (document.getElementById('acf-field_5dea0fc473707')) {
    document.getElementById('acf-field_5dea0fc473707')
      .addEventListener('input', function (el) {
        el.target.value = el.target.value.toUpperCase();
      });
  }

  if (document.getElementById('acf-field_5dea0fd273708')) {
    document.getElementById('acf-field_5dea0fd273708')
      .addEventListener('input', function (el) {
        el.target.value = el.target.value.toUpperCase();
      });
  }

  // Show/hide password fields.
  if (document.getElementById('acf-field_5f157919810e9')) {
    const fieldWrapper = document.querySelector('.acf-field.acf-field-5f157919810e9 .acf-input-wrap');
    fieldWrapper.innerHTML += '<i class="fa fa-eye password-show-hide"></i>';

    const btn = document.querySelector('.acf-field.acf-field-5f157919810e9 .acf-input-wrap .password-show-hide');
    btn.addEventListener('click', function () {
      if (document.getElementById('acf-field_5f157919810e9').type === 'password') {
        document.getElementById('acf-field_5f157919810e9').type = 'text';
      }
      else {
        document.getElementById('acf-field_5f157919810e9').type = 'password';
      }

      btn.classList.toggle('fa-eye');
      btn.classList.toggle('fa-eye-slash');
    });
  }

  if (document.getElementById('acf-field_5f157923810ea')) {
    const fieldWrapper = document.querySelector('.acf-field.acf-field-5f157923810ea .acf-input-wrap');
    fieldWrapper.innerHTML += '<i class="fa fa-eye password-show-hide"></i>';

    const btn = document.querySelector('.acf-field.acf-field-5f157923810ea .acf-input-wrap .password-show-hide');
    btn.addEventListener('click', function () {
      if (document.getElementById('acf-field_5f157923810ea').type === 'password') {
        document.getElementById('acf-field_5f157923810ea').type = 'text';
      }
      else {
        document.getElementById('acf-field_5f157923810ea').type = 'password';
      }

      btn.classList.toggle('fa-eye');
      btn.classList.toggle('fa-eye-slash');
    });
  }
}

export { register };
